<mat-toolbar color="primary">
  <button
    mat-icon-button
    (click)="sidenav.toggle()"
    class="example-icon"
    aria-label="Example icon-button with menu icon"
  >
    <mat-icon>menu</mat-icon>
  </button>
  <div class="logo">
    <img
      src="../../../assets/img/logoExataID_EmBranco_.png"
      alt="ExataID"
      width="150px"
      height="30px"
    />
  </div>
  <span class="spacer01"></span>
  <span class="header-text">Ponto WEB - {{ Cliente }}</span>
  <span class="spacer"></span>
  <span id="usuarioBtn" class="header-text">{{ user?.funcionario?.nome }}</span>
  <button mat-icon-button (click)="logoff()">
    <mat-icon>logout</mat-icon>
  </button>
</mat-toolbar>
<mat-sidenav-container class="app-container">
  <mat-sidenav #sidenav mode="over" [(opened)]="opened" class="app-sidenav">
    <mat-nav-list>
      <mat-list-item (click)="sidenav.toggle();navegar('ez/(ez:ponto)')" *ngIf="user?.funcionario?.registrarPonto">
        <mat-icon>video_camera_front</mat-icon>
        Registrar Ponto
      </mat-list-item>
      <mat-list-item (click)="sidenav.toggle();navegar('ez/(ez:consulta-ponto)')"
        *ngIf="user?.funcionario?.consultaPonto">
        <span><mat-icon>manage_search</mat-icon> Consultar Ponto</span>
      </mat-list-item>
      <mat-list-item (click)="sidenav.toggle();navegar('ez/(ez:ajuste-ponto)')" *ngIf="user?.funcionario?.solAjusPonto">
        <span><mat-icon>edit</mat-icon> Ajuste de Ponto</span>
      </mat-list-item>
      <mat-list-item (click)="sidenav.toggle();navegar('ez/(ez:just-falta)')" *ngIf="user?.funcionario?.justFalta">
        <span><mat-icon>free_cancellation</mat-icon> Justificativa de Falta</span>
      </mat-list-item>
      <mat-list-item (click)="sidenav.toggle();navegar('ez/(ez:espelho-ponto)')" *ngIf="user?.funcionario?.assEspPonto">
        <span><mat-icon>assignment</mat-icon> Espelho de Ponto</span>
      </mat-list-item>
      <mat-list-item (click)="sidenav.toggle();navegar('ez/(ez:saldo-bh)')" *ngIf="user?.funcionario?.saldoBH">
        <span><mat-icon>calculate</mat-icon> Saldo B.H.</span>
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet name="ez"></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
